export const enForgotPassword = {
	forgotPasswordCta: "Send reset link",
	resetYourPassword: "Reset your password",
	submittedFeedbackMessage:
		"Check your inbox. We send an e-mail with instructions on how to reset your password!",
	title: "Forgot password",
	weWillEmailYouALinkToResetYourPassword: "We'll email you a link to reset your password",
	backToLogin: "Back to login",
};
